/**
 * Collection page faceted filtering & sorting.
 * Client-side filtering via data attributes on .product-cell elements.
 */
(function() {
  var grid = document.getElementById('product-grid');
  var countEl = document.getElementById('product-count');
  var clearBtn = document.getElementById('clear-filters');
  var resetBtn = document.getElementById('reset-filters');
  var emptyState = document.getElementById('collection-empty');
  var sortSelect = document.getElementById('sort-select');

  if (!grid) return;

  var cells = Array.from(grid.querySelectorAll('.product-cell'));
  var activeFilters = { category: new Set(), dose: new Set(), effect: new Set(), brand: new Set() };

  // Pill click handlers
  document.querySelectorAll('.filters__pill').forEach(function(pill) {
    pill.addEventListener('click', function() {
      var facet = pill.closest('[data-facet]').dataset.facet;
      var value = pill.dataset.value;
      var pressed = pill.getAttribute('aria-pressed') === 'true';

      if (pressed) {
        pill.setAttribute('aria-pressed', 'false');
        activeFilters[facet].delete(value);
      } else {
        pill.setAttribute('aria-pressed', 'true');
        activeFilters[facet].add(value);
      }

      applyFilters();
    });
  });

  // Sort handler
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      applySort(sortSelect.value);
    });
  }

  // Clear all
  function clearAll() {
    document.querySelectorAll('.filters__pill[aria-pressed="true"]').forEach(function(pill) {
      pill.setAttribute('aria-pressed', 'false');
    });
    Object.keys(activeFilters).forEach(function(key) {
      activeFilters[key].clear();
    });
    applyFilters();
  }

  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  if (resetBtn) resetBtn.addEventListener('click', clearAll);

  function applyFilters() {
    var visibleCount = 0;
    var hasActiveFilters = Object.values(activeFilters).some(function(s) { return s.size > 0; });

    cells.forEach(function(cell) {
      var show = true;

      // Category filter (OR within facet)
      if (activeFilters.category.size > 0) {
        var cats = (cell.dataset.category || '').split(',');
        if (!cats.some(function(c) { return activeFilters.category.has(c); })) show = false;
      }

      // Strength filter
      if (show && activeFilters.dose.size > 0) {
        if (!activeFilters.dose.has(cell.dataset.dose)) show = false;
      }

      // Effect filter (product can have multiple effects)
      if (show && activeFilters.effect.size > 0) {
        var productEffects = (cell.dataset.effect || '').split(',');
        var matchesEffect = false;
        activeFilters.effect.forEach(function(e) {
          if (productEffects.indexOf(e) !== -1) matchesEffect = true;
        });
        if (!matchesEffect) show = false;
      }

      // Brand filter
      if (show && activeFilters.brand.size > 0) {
        if (!activeFilters.brand.has(cell.dataset.brand)) show = false;
      }

      if (show) {
        cell.hidden = false;
        visibleCount++;
      } else {
        cell.hidden = true;
      }
    });

    // Update count
    if (countEl) countEl.textContent = visibleCount;

    // Show/hide clear button
    if (clearBtn) clearBtn.hidden = !hasActiveFilters;

    // Empty state
    if (emptyState) emptyState.hidden = visibleCount > 0;
  }

  function applySort(method) {
    var sorted = cells.slice();

    switch (method) {
      case 'newest':
        sorted.sort(function(a, b) { return b.dataset.date.localeCompare(a.dataset.date); });
        break;
      case 'price-asc':
        sorted.sort(function(a, b) { return parseInt(a.dataset.price) - parseInt(b.dataset.price); });
        break;
      case 'price-desc':
        sorted.sort(function(a, b) { return parseInt(b.dataset.price) - parseInt(a.dataset.price); });
        break;
      case 'potency-desc':
        sorted.sort(function(a, b) { return parseFloat(b.dataset.thc) - parseFloat(a.dataset.thc); });
        break;
      default: // featured - restore original order
        break;
    }

    sorted.forEach(function(cell) {
      grid.appendChild(cell);
    });
  }
})();
